<template>
  <div class="layout_popup" :class="{ shadow }" :style="{ width, height }">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'LayoutPopup',
    props: {
      width: {
        type: [String],
        default: 'auto'
      },

      height: {
        type: [String],
        default: 'auto'
      },

      hide_miss_click: {
        type: [Boolean],
        default: true
      },

      wrapper_selector: {
        type: [String],
        default: ''
      },

      shadow: {
        type: [Boolean],
        default: false
      }
    },

    mounted() {
      if (this.hide_miss_click) {
        if (!this.wrapper_selector) {
          document.body.addEventListener('click', this.hide);
          setTimeout(() => {
            if (!this.$el.classList.contains('is-right')) {
              if (window.innerWidth - parseInt(this.$el.getBoundingClientRect().right, 10) < 0) {
                this.$el.classList.add('is-right');
              } else {
                this.$el.classList.remove('is-right');
              }
            }
          }, 100);
        } else {
          document.querySelector(this.wrapper_selector).addEventListener('click', this.hide);
        }
      }
    },

    destroyed() {
      if (this.hide_miss_click) {
        if (!this.wrapper_selector) {
          document.body.removeEventListener('click', this.hide);
        } else {
          document.querySelector(this.wrapper_selector).removeEventListener('click', this.hide);
        }
      }
    },

    methods: {
      hide(e) {
        if (!this.$el.contains(e.target)) {
          this.$emit('hide');
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .layout_popup {
    background: #ffffff;
    border: 1px solid #d2d6e0;
    box-sizing: border-box;
    border-radius: 2px;
    &.shadow {
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    }
  }
</style>
